module.exports = __webpack_public_path__ + "img/2025-0325-01-01.63bf60bc.png";